// eslint-disable-next-line import/prefer-default-export
export const JOBS_EN = {
  // BB
  SelectCompany: 'Select company template',
  sharedTooltip: 'This will migrate the vacancy to the indicated company.',
  addCancel: 'CANCEL',
  addSave: 'SAVE',
  bigBrotherTitle: 'Big Brother HH',
  // common
  Cancel: 'Cancel',
  Delete: 'Delete',
  Add: 'Add',
  Yes: 'Yes',
  No: 'No',
  Accept: 'Accept',

  // main Jobs
  placeholderSearch: 'Search: CTO',
  newJobButton: 'New job',
  filterButton: 'Filters',
  ProfileAlert: 'PLEASE CREATE YOUR PROFILE',
  HelpVideo: 'Help video',
  IntroductoryVideo: 'Introductory video',

  // Notifications dashboard
  YourCalendar: 'YOUR CALENDAR',
  AddEvent: 'AddEvent',
  NoCalendar: 'No calendar has been added',
  // modalEvent
  InfoEventHeader: 'Information of event ',
  UrlCall: 'Call url: ',
  JoinMeet: 'Join with Google Meet',
  NoEvent: 'No events scheduled',
  Time: 'Time:',
  Date: 'Date:',
  FieldRequired: 'Required field',
  From: 'From:',
  To: 'To:',
  GoToMeet: 'Go to Meet',

  // stepper
  Previous: 'Previous',
  Next: 'Next',
  Publish: 'Publish',
  Vacancy: 'Vacancy',
  Scope: 'Scope',
  PayAndOrPublish: 'Pay and/or publish',

  // modalCreateJob
  CreateHeader: 'Which kind of vacancy do you want to create?',
  RegularVacancy: 'Regular vacancy',
  RegularDescription:
    'Reach candidates actively seeking employment. Publish your vacancy and filter the best talent intelligently',
  OperativeVacancy: 'Operational vacancy',
  OperativeDescription:
    'Simple publication in http://lapieza.io/ and other integrated job sites. Especially for production and service profiles.',
  Headhunting: 'Headhunting',
  HuntingDescription:
    'Get passive profiles that correspond exactly to what you are looking for with our partner LaPieza.io. ',

  // modalMultiposting
  Publishing: 'Publishing',
  Of: 'of',
  PublishingOn: 'Publishing on:',

  // form Create new job
  // formDetails
  Name: 'Name',
  Type: 'Type',
  InOffice: 'In office',
  Remote: 'Remote',
  Address: 'Address',
  Seniority: 'Seniority',
  Contract: 'Contract',
  Category: 'Category',
  Carrer: 'Carrer',
  campus: 'Campus',
  placeholderSelectCategories: 'Select categories',
  Wage: 'Wage',
  Range: 'Range',
  Negotiable: 'Negotiable',
  Minimum: 'Minimum',
  Maximum: 'Maximum',
  RequiresCv: 'Requires CV',
  Description: 'Description',
  WantConfidential: 'Do you want it to be confidential?',
  WantNotification: 'Do you want your people to be notified when someone applies for it?',
  Emails: 'Emails:',
  HaventAdded: 'You have not added any email',
  WantOwners: 'Do you want to add owners for this vacancy?',
  Recruiter: 'Recruiter',
  User: 'User',
  ColumnsTemplate: 'Select a columns template',
  placeholderSearchTemplates: 'Search templates',
  AssignVacancysName: "Assign vacancy's name",
  UploadCustom: 'Upload custom image',
  HorizontalImg: 'Image should be horizontal',
  // seniorities
  Intern: 'Intern',
  Flexible: 'Flexible',
  Junior: 'Junior',
  Senior: 'Senior',
  Ejecutivo: 'Executive',
  Otro: 'Other',
  // contract
  Freelance: 'Freelance',
  Temporal: 'Temporal',
  HalfTime: 'Half time',
  FullTime: 'Full time',
  // categories
  Administration: 'Administration',
  Banking: 'Banking',
  Law: 'Law',
  Development: 'Web development / IT',
  Design: 'Design',
  Edtech: 'Edtech',
  Finances: 'Finances',
  Fintech: 'Fintech',
  Healathtech: 'Healthtech',
  Humanities: 'Humanities',
  CreativeIndustries: 'Creative industries',
  Engineering: 'Engineering',
  Insurtech: 'Insurtech',
  Legal: 'Legal',
  Logistics: 'Logistics',
  Management: 'Management',
  DigitalMarketing: 'Digital marketing',
  Fashion: 'Fashion',
  OngSocial: "ONG's, social, operations",
  Psychology: 'Psychology',
  Proptech: 'Proptech',
  HumanResources: 'Human resources',
  Health: 'Health',
  Insurances: 'Insurances',
  Sells: 'Sells',
  Other: 'Others',

  // Hard skills
  SelectHardSkills: 'Select the hard skills that will be tested on applicants',
  MaximumSkills:
    'You can select a maximum of 3 hard skills. We wil apply a small test to the applicants on these hard skills.',
  CustomizedQuetions: 'Add customized questions',
  Optional: '(Optional)',
  HaveToAnswer: 'In order to apply, applicants will have to answer them.',
  AddQuestion: 'Add question',
  UpdateQuestion: 'Update question',
  Question: 'Question',
  QuestionType: 'Question type',
  OpenQuestion: 'Open question',
  OpenShortQuestion: 'Open question (Short answer)',
  OpenExtendedQuestion: 'Open question (Extense answer)',
  ClosedQuestion: 'Closed question',
  MultipleChoiceQuestion: 'Multiple choice question',
  RangeQuestion: 'Range answer question',
  placeholderCorrectAnswer: 'Correct answer',
  placeholderTimeToAnswer: 'Time to answer (seconds)',
  AddOption: 'Add option',
  UpdateOption: 'Update option',
  placeholderOption: 'Option',
  // skills
  LogMathReasoning: 'Logical mathematical reasoning',
  VerbalReasoning: 'Verbal reasoning',
  English: 'English',
  Marketing: 'Digital marketing',
  Startups: 'Startups knowledge and capital raising',
  Mexico: 'General culture from México',
  Programming: 'Basic programming',

  // Alcance
  Title: 'Did you know it cost you less money if you publish your vacancies in LinkedIn through our platform?',
  TitleDesc: 'Increase the extent of your vacancies by publishing them in universities and specialized platforms.',
  JobPlatforms: 'Job platforms:',
  Days: 'days',
  Free: 'Free',
  OtherPlatforms: 'Other free platforms:',
  Platforms: 'Platforms',
  InstitutionsOnEachBlock: 'Institutions on each block',
  tooltipOcc: 'Simple 60 days publication on behalf of LaPieza.io.',
  tooltipIndeed: '15 days publication on behalf of your company. Average savings of 500 MXN per publication.',
  tooltipLinkedIn30: '30 days publication on behalf of your company. Average savings of 5,000 MXN per publication.',
  tooltipLinkedIn15: '15 days publication on behalf of your company. Average savings of 2,000 MXN per publication.',
  // blocks
  Institute: 'Institute',
  IT: 'Web development and IT',
  ITExample: '(Frontend, Fullstack, Backend, Testers)',
  engineering: 'Other engineering',
  engineeringExample: '(Physics, Chemistry)',
  bussines: 'Business',
  bussinesExample: '(Economy, Admin, HR, MKT, Design)',
  humanities: 'Humanities',
  humanitiesExample: '(Literature, Arts)',
  medicine: 'Health sciences',
  medicineExample: '(Medicine, Veterinary, Dentist)',
  services: 'Operative and services',
  servicesExample: '(Sells executives, operations, logistic)',
  social: 'Social sciences',
  socialExample: '(Law, Psychology, Education)',

  // Publish
  Use: 'Use',
  Do: 'Do',
  PleaseWait: 'Please, wait...',
  NoPayment: 'This publication does not require a payment.',

  // deleteJob
  choosePauseOrClosed: 'Are you sure you want pause the vacancy or do you prefer to close the vacancy?',
  descriptionPauseOrClose: 'If the vacancy is closed, you will no longer be able to make changes.',
  DeleteHeader: 'Paused vacancy',
  ConfirmationMessage: 'Are you sure you want to paused this vacancy?',
  ConfirmationMessageClosed: 'Are you sure you want to closed this vacancy?',
  WhatShouldWeDo: 'What should we do with your applicants? notify them by email?',
  Notify: 'Notify',
  DoNotNotify: 'Do not notify',
  pause: 'Paused',
  closed: 'Closed',

  // deleteJob
  DeleteVacancy: 'Delete vacancy',
  ConfirmationDelete: 'Are you sure you want to delete this vacancy permanently?',
  DeleteWarning: 'This action will delete all vacancy info and cannot be reverted.',
  // modalBlocked
  BlockedHeader: 'This action cannot be done',
  BlockedMessage:
    'Your current plan does not allow you to have more than one active vacancy, you can pause your active vacancy \n' +
    'and then try again or if you prefer, you can contact our team to: pol@lapieza.io',
  ChangePlan: 'Change plan',
  Contact: 'Contact us',
  // modalFilters
  All: 'All',
  ActivePlural: 'Active',
  PausedPlural: 'Paused',
  ClosedPlural: 'Closed',
  Predefined: 'Predefined',
  Newer: 'Newer',
  Older: 'Older',
  Owners: 'Owners',
  ShowVacancies: 'Show vacancies',
  OrderBy: 'Order by',
  Reset: 'Reset',

  // Vacancies cards
  tooltipPause: 'Pause',
  tooltipActivate: 'Activate',
  tooltipSee: 'See',
  tooltipShare: 'Share',
  tooltipEdit: 'Edit',
  tooltipAnalytics: 'Analytics',
  tooltipDelete: 'Permanent',
  Confidential: 'Confidential',

  // Modal de crear evento
  newEvent: 'New event',
  updateEvent: 'Update event',
  titleEvent: 'Title of event',
  descriptionEvent: 'Description event',
  start: 'Start',
  end: 'End',
  addMeet: 'Add Meet',
  notifyGuest: 'Notify Guest',
  guest: 'Guest',

  // Notifications
  OnlyNumbersAllowed: 'Only numbers are allowed',
  AtLeastName: 'You must name the vacancy at least',
  EmailAlreadyAdded: 'Email already added',
  InvalidEmail: 'Invalid email',
  OnlyThreeHard: 'You can select only three hard skills',
  PaymentRejected: 'The payment was rejected by your bank, try again or get in touch with your bank',
  UrlCopied: 'URL copied',
  StartingDeletion: 'Starting deletion',
  ComingSoon: 'Coming soon',
  Document: 'Document',
  SuccessfullyDeleted: 'successfully deleted',

  // Modal Edit Vacancy
  EditVacancy: 'Edit Vacancy',
  SaveChanges: 'Save Changes',
  EditSuccess: 'Changes saved',
  ErrorUpdateData: 'An error occurred while updating',
};
